import React, { useRef, useEffect } from 'react';
import { I as Icon } from './Icon-8KKXFsxm.js';

var styles = {"search":"MIyb-oFZg9w-","searchInput":"WZPK91I4aJs-","clearSearch":"_7loHrVUe-Rk-"};

function ComboboxContentSearch(props) {
    const searchRef = useRef(null);
    useEffect(() => {
        if (props.open) {
            setTimeout(() => {
                var _a;
                (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        }
    }, [props.open]);
    return (React.createElement("div", { className: styles.search },
        React.createElement("input", { type: "search", ref: searchRef, className: styles.searchInput, placeholder: props.placeholder ? `Search ${props.placeholder}` : "Search", onChange: (event) => handleSearch(event), value: props.searchValue }),
        props.searchValue && (React.createElement("button", { className: styles.clearSearch, onClick: clearSearch, type: "button", "data-testid": "ATL-Combobox-Content-Search-Clear", "aria-label": "Clear search" },
            React.createElement(Icon, { name: "remove", size: "small" })))));
    function clearSearch() {
        var _a;
        props.setSearchValue("");
        props.handleSearchChange("");
        (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    function handleSearch(event) {
        props.setSearchValue(event.currentTarget.value);
        props.handleSearchChange(event.currentTarget.value);
    }
}

export { ComboboxContentSearch as C };
